import React from 'react';
import ReactDOM from 'react-dom';
import './sass/index.scss';
import Portfolio from './components/Portfolio';
import { client } from "./contentfulClient";

export async function getStaticProps(locale) {
    
  const headerResponse =  await client.getEntry("7ppGz7fVhRq1JPek7U6ObD",{locale:locale});
  //Include 10 c'est pour inclure les links (developpeurs)
  const galleryResponse = await client.getEntry("4L0uMFXt1fbu1fBI1Cn3Y0",{locale:locale,include:10});
  const footerResponse = await client.getEntry("5oLUA4UZ50sjmu2RI4HBPs",{locale:locale});

  return{
      props:{
          header: headerResponse,
          gallery: galleryResponse,
          footer: footerResponse
      }
  }
      
  
}

ReactDOM.render(
  
  <React.StrictMode>
          <Portfolio date={new Date()} />
          
  </React.StrictMode>,
  document.getElementById('root')

  
);


